import { TrailerTypeFormModel } from "../../app/form";

export class TrailerTypeRequest {
  name: string;

  constructor(trailerTypeForm: TrailerTypeFormModel) {
    this.name = trailerTypeForm.name;
  }
}
